import { Controller } from "@hotwired/stimulus"

const OPTIONS = {
  text: ["max_length"], long: ["max_length"], int: ["unit", "min", "max", "by_year"],
  dec: ["unit", "min", "max", "decimals", "by_year"], money: ["period", "by_year"], pct: ["min", "max", "by_year"],
  date: ["date_format"], choice: ["choices"], multi: ["choices"], party: ["targets"], doc: ["document_type"]
}

// Formulaire de champ : options propres au type, clé proposée depuis le libellé, historisation par
// défaut selon le type, aperçu rechargé pendant la saisie.
export default class extends Controller {
  static targets = ["label", "key", "type", "options", "historized", "preview"]
  static values = { previewUrl: String, historizedTypes: Array }

  connect() {
    this.keyEdited = this.keyTarget.value.length > 0
    this.keyTarget.addEventListener("input", () => { this.keyEdited = true })
    this.lastType = this.typeTarget.value
  }

  disconnect() { clearTimeout(this.timer) }

  change(event) {
    if (event.target === this.typeTarget) this.typeChanged()
    if (event.target === this.labelTarget && !this.keyEdited && !this.keyTarget.readOnly) {
      this.keyTarget.placeholder = this.slug(this.labelTarget.value) || this.keyTarget.placeholder
    }
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.refreshPreview(), 300)
  }

  typeChanged() {
    const visible = OPTIONS[this.typeTarget.value] || []
    this.optionsTarget.querySelectorAll("[data-option]").forEach((element) => {
      element.hidden = !visible.includes(element.dataset.option)
    })
    if (this.lastType !== this.typeTarget.value) {
      this.historizedTarget.checked = this.historizedTypesValue.includes(this.typeTarget.value)
      this.lastType = this.typeTarget.value
    }
  }

  refreshPreview() {
    const data = new FormData(this.element)
    const params = new URLSearchParams()
    for (const [name, value] of data.entries()) {
      if (name.startsWith("definition[")) params.append(name, value)
    }
    this.previewTarget.src = `${this.previewUrlValue}?${params}`
  }

  slug(value) {
    const stop = ["de", "du", "des", "la", "le", "les", "l", "d", "un", "une", "et", "a", "au", "aux", "en"]
    return value.normalize("NFD").replace(/\p{Mn}/gu, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim()
      .split(" ").filter((word) => word && !stop.includes(word)).join("_").slice(0, 60)
  }
}
